export default __webpack_public_path__ + "static/media/0011.01e579fd.jpg";